import { InitializerType } from './InitializerType';
export class Initializer {
    assetsCore = new InitializerType();
    compatibility = new InitializerType();
    assets = new InitializerType();
    ui = new InitializerType();
    loaders = new InitializerType();
    requestInit = new InitializerType();
    requestSettings = new InitializerType();
    requestTranslations = new InitializerType();
    isReadyToLoadAssets() {
        const result = this.compatibility.isReady() && this.requestInit.isReady() && this.loaders.isReady();
        if (result) {
            this.compatibility.setDone();
            this.requestInit.setDone();
            this.loaders.setDone();
        }
        return result;
    }
    isReadyToCreateAssets() {
        const result = this.assetsCore.isReady();
        if (result) {
            this.assetsCore.setDone();
        }
        return result;
    }
    isReadyToEndInitialization() {
        const result = (this.requestSettings.isReady() &&
            this.requestTranslations.isReady() &&
            this.assets.isReady() &&
            this.ui.isReady());
        if (result) {
            this.requestSettings.setDone();
            this.requestTranslations.setDone();
            this.assets.setDone();
            this.ui.setDone();
        }
        return result;
    }
}
//# sourceMappingURL=Initializer.js.map